import { type LeaderboardItem } from '@app/client/common/structs/competitions';
import { compare } from '@app/helpers';

export function sortedEntries(entries: LeaderboardItem[]) {
    return entries.sort((rankA, rankB) => compare(rankA.rank, rankB.rank));
}
